module.exports = __webpack_public_path__ + "images/kaitori_bonus_cp_lp/may/mainvisual-title@2x_1947ebe622f9513f675a5dfd8e53fa02.png";